import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ISuccessSingleResponse } from '@shared/models/success-single-response';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import {
  IGetUserResponse,
  IGetUsersResponse,
} from '../models/get-users-response';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private baseUrl: string = environment.SMART_API_URL;
  private readonly http: HttpClient = inject(HttpClient);

  private userSubject: BehaviorSubject<null> = new BehaviorSubject<null>(null);
  public users$: Observable<null> = this.userSubject.asObservable();

  getUsers(): Observable<ISuccessSingleResponse<IGetUsersResponse>> {
    const getUsersUrl: string = `${this.baseUrl}users-backoffice`;
    const params = {
      isActive: 1,
    };
    const response: Observable<ISuccessSingleResponse<IGetUsersResponse>> =
      this.http.get<ISuccessSingleResponse<IGetUsersResponse>>(getUsersUrl, {
        params,
      });

    return response;
  }

  getUserById(
    userId: number
  ): Observable<ISuccessSingleResponse<IGetUserResponse>> {
    const getUserByIdUrl: string = `${this.baseUrl}users-backoffice/${userId}`;
    const response: Observable<ISuccessSingleResponse<IGetUserResponse>> =
      this.http.get<ISuccessSingleResponse<IGetUserResponse>>(getUserByIdUrl);

    return response;
  }

  deleteUser(userId: number): Observable<void> {
    const deleteUserUrl: string = `${this.baseUrl}users-backoffice/${userId}`;
    const response: Observable<void> = this.http
      .delete<void>(deleteUserUrl)
      .pipe(tap(() => this.userSubject.next(null)));

    return response;
  }
}
